<template>
  <div class="text-center">
    <v-btn text class="mr-4" @click="$router.go(-1)">{{
      $t("button.back")
    }}</v-btn>
    <v-btn color="success" class="mr-4" @click="authorize(true)">{{
      $t("button.authorize")
    }}</v-btn>
    <v-btn color="error" class="mr-4" @click="authorize(false)">
      {{ $t("button.deny") }}
    </v-btn>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: {
    object_type: String
  },

  methods: {
    authorize(bool) {
      let path =
        this.$store.state.endpoint +
        "/direction/moderatedOperations/authorize/" +
        this.object_type +
        "/" +
        this.$route.params.id;
      let data = {
        authorized: bool
      };
      var textResponse = "";
      axios
        .patch(path, data)
        .then(response => {
          if (bool) {
            textResponse = this.$t("forms.director_actions.authorize");
          } else {
            textResponse = this.$t("forms.director_actions.deny");
          }

          this.$store.commit("alert", {
            color: "success",
            text: textResponse
          });
          this.$router.push("/direction/forms/authorize");
        })
        .catch(error => {
          console.log(error);
          if (bool) {
            textResponse = this.$t("forms.director_actions.error.authorize");
          } else {
            textResponse = this.$t("forms.director_actions.error.deny");
          }
          this.$store.commit("alert", {
            color: "error",
            text: textResponse
          });
        });
    }
  }
};
</script>
